<form [formGroup]="agreementForm">
    <app-form-section>
        <app-form-row>
            <app-form-group class="report-container">
                <div class="box">
                    <app-form-row>
                        <app-form-group>
                            <app-agreement-periods
                                [periodForm]="periodForm"
                                [agreementForm]="agreementForm"
                                [showPotentialValidationMessages]="true"
                            ></app-agreement-periods>
                        </app-form-group>
                    </app-form-row>
                </div>
                <div class="box">
                    <app-form-row *ngIf="showReminder()">
                        <app-form-group>
                            <app-agreement-reminder
                                [reminderForm]="reminderForm"
                                [periodForm]="periodForm"
                                [agreementName]="agreementForm.controls.details.controls.name.value"
                                [showPotentialValidationMessages]="true"
                            ></app-agreement-reminder>
                        </app-form-group>
                    </app-form-row>
                </div>
            </app-form-group>

            <!-- <div class="box">
                <app-form-group class="report-container">
                    <app-pdf-viewer [id]="'file2'" [file]="fileForm"></app-pdf-viewer>
                </app-form-group>
            </div> -->
        </app-form-row>
    </app-form-section>
</form>

<!-- Edit mode enabled template-->
<ng-template #editModeFooterTemplate>
    <button class="secondary" (click)="cancel()">
        {{ 'BUTTONS.CANCEL' | translate }}
    </button>
    <button class="primary green" [class.loading]="submitting" [disabled]="submitting" (click)="save()">
        {{ 'BUTTONS.SAVE' | translate }}
    </button>
</ng-template>
